import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  // Solution ABSOLUE pour headers sticky et mobile
  // Force le scroll à EXACTEMENT 0,0 même avec headers fixed
  
  const forceScrollToAbsoluteTop = () => {
    // Méthode 1: ScrollTo avec options explicites
    try {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant' // ou 'auto' pour éviter l'animation
      });
    } catch (e) {
      window.scrollTo(0, 0);
    }
    
    // Méthode 2: Manipulation directe du scrollTop
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // Méthode 3: Forcer avec style (pour certains cas iOS)
    document.documentElement.style.scrollBehavior = 'auto';
    window.scroll(0, 0);
    
    // Méthode 4: Reset tous les conteneurs scrollables
    const allElements = document.querySelectorAll('*');
    allElements.forEach(element => {
      if (element.scrollTop > 0) {
        element.scrollTop = 0;
      }
      if (element.scrollLeft > 0) {
        element.scrollLeft = 0;
      }
    });
  };
  
  // ÉTAPE 1: useLayoutEffect - Synchrone AVANT le paint
  useLayoutEffect(() => {
    // Force immédiat
    forceScrollToAbsoluteTop();
    
    // Double force pour iOS/Safari
    setTimeout(() => forceScrollToAbsoluteTop(), 0);
  }, [pathname]);

  // ÉTAPE 2: useEffect - Après render avec vérification persistante
  useEffect(() => {
    // Force immédiat
    forceScrollToAbsoluteTop();
    
    // Via RAF - attend le prochain frame du navigateur
    requestAnimationFrame(() => {
      forceScrollToAbsoluteTop();
      
      // Double RAF - après layout ET paint
      requestAnimationFrame(() => {
        forceScrollToAbsoluteTop();
        
        // Triple RAF - pour les cas ultra-résistants
        requestAnimationFrame(() => {
          forceScrollToAbsoluteTop();
        });
      });
    });
    
    // Fonction de vérification et correction persistante
    const verifyAndCorrectScroll = () => {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      if (currentScroll !== 0) {
        console.log(`⚠️ Scroll non-zéro détecté: ${currentScroll}px - Correction en cours...`);
        forceScrollToAbsoluteTop();
      }
    };
    
    // Timeouts progressifs avec vérification
    const timeouts = [
      setTimeout(() => { forceScrollToAbsoluteTop(); verifyAndCorrectScroll(); }, 0),
      setTimeout(() => { forceScrollToAbsoluteTop(); verifyAndCorrectScroll(); }, 1),
      setTimeout(() => { forceScrollToAbsoluteTop(); verifyAndCorrectScroll(); }, 10),
      setTimeout(() => { forceScrollToAbsoluteTop(); verifyAndCorrectScroll(); }, 50),
      setTimeout(() => { forceScrollToAbsoluteTop(); verifyAndCorrectScroll(); }, 100),
      setTimeout(() => { forceScrollToAbsoluteTop(); verifyAndCorrectScroll(); }, 150),
      setTimeout(() => { forceScrollToAbsoluteTop(); verifyAndCorrectScroll(); }, 200),
      setTimeout(() => { forceScrollToAbsoluteTop(); verifyAndCorrectScroll(); }, 300),
      setTimeout(() => { forceScrollToAbsoluteTop(); verifyAndCorrectScroll(); }, 500), // Vérification finale
    ];

    return () => {
      timeouts.forEach(clearTimeout);
    };
  }, [pathname]);

  return null;
}

export default ScrollToTop;
